export const SSID_SECTION_EVENT = 'canvas-agent:ssid:section';
export const SSID_FILTER_EVENT = 'canvas-agent:ssid:filter';
export const SSID_FOCUS_EVENT = 'canvas-agent:ssid:focus';
export const SSID_CREATE_MODAL_EVENT = 'canvas-agent:ssid:create-modal';
export const SSID_CONFIGURE_MODAL_EVENT = 'canvas-agent:ssid:configure-modal';
export const SSID_DELETE_MODAL_EVENT = 'canvas-agent:ssid:delete-modal';
